import React from 'react';
import { TextWithLF } from '@doda/common/src/components/TextWithLF';
import { SectionItem } from '../../SectionItem';
import { SubSection } from '../../SubSection';
import styles from '../index.module.scss';

/**
 * WorkingTimeのProps
 */
interface WorkingTimeProps {
  /** 勤務時間 */
  workTime: string | undefined;
  /** 平均残業時間 */
  averageOverworkHours: string | undefined;
  /** 平均残業時間説明 */
  averageOverworkHoursExplanation: string | undefined;
}
/**
 * WorkingTimeのコンポーネント
 */
export const WorkingTime: React.FC<WorkingTimeProps> = ({
  workTime,
  averageOverworkHours,
  averageOverworkHoursExplanation,
}) => {
  return (
    <SectionItem label="勤務時間">
      {workTime && <TextWithLF text={workTime} />}
      {averageOverworkHours && (
        <div className={styles['jobSearchDetail-body__subSectionItem']}>
          <SubSection label="平均残業時間">
            {`月${averageOverworkHours}時間${averageOverworkHoursExplanation}`}
          </SubSection>
        </div>
      )}
    </SectionItem>
  );
};
